// extracted by mini-css-extract-plugin
export default {"title":"NewsList_title__hOZQO"};